<canvas #canvas class="canvasRenderer"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp($event)"
        (panend)="onPanEnd($event)"
        (panmove)="onPanMove($event)"
        (panstart)="onPanStart($event)"
        (tap)="onTap($event)"
        (touchend)="onTouchModelMoveEnd($event)"
        (touchmove)="onTouchModelMove($event)"
        (touchstart)="onDblTouch($event)"
        (window:resize)="onResize()"
        [ngStyle]="{ cursor: editorControlService.customEvent === 'drawOnTextureBrush' ||
                             editorControlService.customEvent === 'erase' ? 'crosshair': 'default' }"
></canvas>

